import { ref } from 'vue';

export const submitting = ref(false);
export const errorMessage = ref(null);
